import React, { Component } from "react";
import axios from "axios";
import domain from ".././../../../domain";

import { Row, Col, Card, CardBody } from "mdbreact";

const moment = require("moment-timezone");
// function indexN(cell, row, enumObject, index) {
//     return (<div>{index+1}</div>)
// }
// function dateFormatter(cell) {
//  return moment(cell).tz("Asia/Kolkata").format("MM/DD/YYYY")

// }

class ConsolidatedSessionFeedback extends Component {
  constructor() {
    super();
    this.state = {
      result: null,
      course_name: null,
    };
  }

  componentDidMount() {
    this.getReport();
    this.getCourse();
  }

  async getReport() {
    let courseId = this.props.match.params.id;
    let result = await axios.get(
      `${domain.DBServer}/session-consolidated-report/${courseId}`
    );
    this.setState({
      result: result.data,
    });
  }

  async getCourse() {
    let courseId = this.props.match.params.id;
    let result = await axios.get(`${domain.DBServer}/fetch-course/${courseId}`);
    this.setState({
      course_name: result.data[0].title,
      status: result.data[0].status,
    });
  }

  render() {
    console.log(this.state.result);
    let content = this.state.result
      ? this.state.result.map((report, key) => {
          let a = report.comment.split("|");
          console.log(a);
          let k = a.filter((item) => {
            return item !== "";
          });
          console.log(k);
          return (
            <tr key={key}>
              <td>{key + 1}</td>
              <td>{report.lecturer_name}</td>
              <td>{report.title}</td>
              <td>{moment(report.session_date).format("MMMM Do YYYY")}</td>
              <td>{report.start_time}</td>
              <td>{report.end_time}</td>
              <td>{report.average}</td>

              <td style={{ textAlign: "justify" }}>
                <ol>
                  {" "}
                  {k.map((item, key) => {
                    return <li key={key}>{item}</li>;
                  })}
                </ol>{" "}
              </td>
            </tr>
          );
        })
      : null;

    return (
      <div>
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <h3 style={{ textAlign: "center", color: "blue" }}>
                  {this.state.course_name}
                </h3>

                <table
                  className="table table-striped table-bordered table-responsive-md"
                  cellSpacing="0"
                  width="100%"
                >
                  <thead
                    style={{ textAlign: "center", backgroundColor: "#33b5e5" }}
                  >
                    <tr>
                      <th scope="col" width="20">
                        Lecture No
                      </th>
                      <th scope="col" width="50">
                        Lecturer Name
                      </th>
                      <th scope="col" width="100">
                        Title of the Session
                      </th>
                      <th scope="col" width="100">
                        Date{" "}
                      </th>
                      <th scope="col" width="50">
                        Start Time
                      </th>
                      <th scope="col" width="50">
                        End Date
                      </th>

                      <th scope="col" width="20">
                        Average
                      </th>
                      <th scope="col" width="250">
                        Comments
                      </th>
                    </tr>
                  </thead>

                  <tbody>{content}</tbody>
                </table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ConsolidatedSessionFeedback;
